// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e5-2";
export var aiChatCartContainerExit = "_e5-4";
export var aiChatContainerLarge = "_e5-0";
export var aiChatContainerSmall = "_e5-1";
export var aiChatIcon = "_e5-6";
export var slideInFromRight = "_e5-3";
export var slideOutToRight = "_e5-5";